
$(document).ready(function () {

// Custom Icon With Text

$(".slick-testimonials").slick({
    dots: true,
    arrows: false,
    infinite: true,
    autoplay: true,
    speed: 600,
    autoplaySpeed: 4000,
    slidesToShow: 1,
    slidesToScroll: 1
  });


  $('#slick-as-seen').slick({
    dots: false,
    arrows: false,
    infinite: true,
    autoplay: true,
    autoplaySpeed: 0,
    pauseOnHover: true,
    cssEase: 'linear',	
    slidesToShow: 8,
    speed: 4000,
    slidesToScroll: 1,
    responsive: [
        {
        breakpoint: 1199,
        settings: {
          slidesToShow: 6,
          slidesToScroll: 1,
        }
      },
      {
        breakpoint: 991,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 1,
        }
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        }
      }
    ]
  });

  // Review Grid slider for mobile screen
});


const PARTICLE_COUNT = 220;

  function startAnimation(canvas) {
    const ctx = canvas.getContext("2d");

    function resize() {
      canvas.width = canvas.offsetWidth;
      canvas.height = canvas.offsetHeight;
    }
    resize();

    function rand(min, max) {
      return Math.random() * (max - min) + min;
    }

    class Particle {
      constructor(type) {
        this.type = type; // "heart" or "sparkle"
        this.reset();
      }

      reset() {
        this.x = rand(0, canvas.width);
        this.y = rand(-canvas.height, canvas.height);
        this.size = this.type === "heart" ? rand(6, 10) : rand(1, 2);
        this.speedY = this.type === "heart" ? rand(0.4, 0.8) : rand(0.6, 1.4);
        this.speedX = rand(-0.2, 0.2);
        this.opacity = rand(0.4, 1);
        this.opacitySpeed = rand(0.003, 0.02);
      }

      drawHeart() {
        ctx.save();
        ctx.translate(this.x, this.y);
        ctx.scale(this.size / 10, this.size / 10);

        ctx.beginPath();
        ctx.moveTo(0, 3);
        ctx.bezierCurveTo(-5, -3, -10, 3, 0, 12);
        ctx.bezierCurveTo(10, 3, 5, -3, 0, 3);
        ctx.closePath();

        ctx.fillStyle = "rgba(255, 80, 120, 0.9)";
        ctx.shadowBlur = 12;
        ctx.shadowColor = "rgba(255, 80, 120, 0.9)";
        ctx.fill();
        ctx.restore();
      }

      drawSparkle() {
        ctx.save();
        ctx.translate(this.x, this.y);
        ctx.rotate(Math.PI / 4);

        ctx.globalAlpha = this.opacity;
        ctx.shadowBlur = 12;
        ctx.shadowColor = "rgba(255, 220, 160, 0.9)";
        ctx.fillStyle = "rgba(255, 255, 255, 0.9)";

        const spikes = 4;
        const outerRadius = this.size * 3;
        const innerRadius = this.size * 1.2;

        let rot = Math.PI / 2 * 3;
        let step = Math.PI / spikes;

        ctx.beginPath();
        ctx.moveTo(0, -outerRadius);

        for (let i = 0; i < spikes; i++) {
          ctx.lineTo(
            Math.cos(rot) * outerRadius,
            Math.sin(rot) * outerRadius
          );
          rot += step;

          ctx.lineTo(
            Math.cos(rot) * innerRadius,
            Math.sin(rot) * innerRadius
          );
          rot += step;
        }

        ctx.closePath();
        ctx.fill();
        ctx.restore();
      }

      update() {
        this.y += this.speedY;
        this.x += this.speedX;

        // sparkle flicker
        this.opacity += this.opacitySpeed;
        if (this.opacity > 1 || this.opacity < 0.3) {
          this.opacitySpeed *= -1;
        }

        if (this.y > canvas.height + 20) {
          this.reset();
          this.y = -10;
        }
      }

      draw() {
        if (this.type === "heart") {
          this.drawHeart();
        } else {
          this.drawSparkle();
        }
      }
    }

    const particles = [];
    for (let i = 0; i < PARTICLE_COUNT; i++) {
      particles.push(
        new Particle(Math.random() > 0.65 ? "heart" : "sparkle")
      );
    }

    function animate() {
      ctx.clearRect(0, 0, canvas.width, canvas.height);
      particles.forEach(p => {
        p.update();
        p.draw();
      });
      requestAnimationFrame(animate);
    }

    animate();
    window.addEventListener("resize", resize);
  }

  document.addEventListener("DOMContentLoaded", () => {
    document.querySelectorAll(".snow-canvas").forEach(startAnimation);
  });

